// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo{width:100%;margin:auto;display:block}.footer{background-color:#071d41;z-index:999}@media print{.layout-sidebar,.noPrint{display:none}}", ""]);
// Exports
module.exports = exports;
